'use client';
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@ui/icons';
import { StyledGlassCarouselArrow } from './styles.js';

export const GlassCarouselArrow = ({
  direction,
  onClick,
  disabled = false,
  'aria-label': ariaLabel,
  iconColor = 'hero.plum',
  edgePosition = 'overlap',
}) => (
  <StyledGlassCarouselArrow
    type="button"
    $direction={direction}
    $edgePosition={edgePosition}
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel}
  >
    <Icon
      iconName={direction === 'prev' ? 'arrow-left' : 'arrow-forward'}
      alt=""
      size="22px"
      color={iconColor}
    />
  </StyledGlassCarouselArrow>
);

GlassCarouselArrow.displayName = 'GlassCarouselArrow';

GlassCarouselArrow.propTypes = {
  direction: PropTypes.oneOf(['prev', 'next']).isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  'aria-label': PropTypes.string.isRequired,
  iconColor: PropTypes.string,
  edgePosition: PropTypes.oneOf(['inset', 'overlap']),
};
